import React, { useState } from "react";
import { FaBars, FaTimes,FaGithub,FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-scroll";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [color,setColor] = useState(false);

  const changeColor =()=>{
    if(window.scrollY>=90){
       setColor(true)
    }else{
      setColor(false)
    }
  }

  window.addEventListener('scroll',changeColor);

  const links = [
    {
      id: 1,
      link: "home",
    },
    {
      id: 2,
      link: "projects",
    },
    {
      id: 3,
      link: "about",
    },
   
   
  ];

  return (
   
    <div className={color ? "scroll_header  ":"header"}>
       
     
        <h1 className="text-6xl font-signature  ml-2">Anmol</h1>
    

      <ul className="hidden md:flex">
        {links.map(({ id, link }) => (
          <li
            key={id}
            className="px-6 cursor-pointer capitalize font-semibold text-lg text-black rounded-lg ring-0 hover:scale-105 hover:ring-1 hover:ring-inset duration-200"
          >
            <Link to={link} smooth duration={500}>
              {link}
            </Link>
          </li>
        ))}
       
      </ul>
      <li className="  hidden md:flex items-center justify-center  ">
         <a href="https://github.com/Anmo1Sen" className="mx-6 rounded-full hover:bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500"> <FaGithub size={30}   /></a>
         <a href= "https://www.linkedin.com/in/anmol-sen-603836126/"  className="mx-6 rounded-sm  hover:bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500"> <FaLinkedinIn size={30}   /></a>
          
          <a href="https://gateway.pinata.cloud/ipfs/QmPma8ETmerHcJLucTY4qGNsu78YzmHPA8nrHYnmY1eRbF?_gl=1*20di6o*_ga*MTQxNDg5NDE4Ny4xNjY0MTY2ODM2*_ga_5RMPXG14TE*MTY3NjIwMDQzOC41LjEuMTY3NjIwMDQ3Mi4yNi4wLjA." 
           target="_blank" className=" bg-black text-white px-4 py-2 rounded-lg hover:bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 ">Resume</a>
        </li>

      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-10 text-black md:hidden "
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {nav && (
        <div>
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-r from-red-200 via-red-300 to-yellow-200 text-black scroll">
          {links.map(({ id, link }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-4xl"
            >
              <Link
                onClick={() => setNav(!nav)}
                to={link}
                smooth
                duration={500}
              >
                {link}
              </Link>
            </li>
            
            
          ))}
        </ul>
       
       </div>
      )}
    </div>
  
  );
 
};

export default Navbar;